import ContactUsItem from './ContactUsItem';
import { ContactUsItemProps, ContactUsItemValueProps } from './types';

export type { ContactUsItemProps, ContactUsItemValueProps };
export default ContactUsItem;
